import * as React from "react"
import { Link } from "gatsby";
import { graphql, useStaticQuery } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

function Services({ category }) {

	const data = useStaticQuery(graphql`
    query {
		citizenshipImage: file(relativePath: { eq: "citizenship-hub.webp" }) {
			childImageSharp {
			gatsbyImageData
			}
		}
		estatePlanningImage: file(relativePath: { eq: "estate-planning-thumb.jpg" }) {
			childImageSharp {
				gatsbyImageData
			}
		}
		financialPlanningImage: file(relativePath: { eq: "financial-planning-thumb.jpg" }) {
			childImageSharp {
			gatsbyImageData
			}
		}
				investmentsImage: file(relativePath: { eq: "investments-thumb.jpg" }) {
			childImageSharp {
			gatsbyImageData
			}
		}
		retirementPlanningImage: file(relativePath: { eq: "retirement-planning-thumb.jpg" }) {
			childImageSharp {
			gatsbyImageData
			}
		}
		wealthManagementImage: file(relativePath: { eq: "wealth-management-thumb.jpg" }) {
			childImageSharp {
				gatsbyImageData
			}
		}
	}

  `);


	const services = [
		{
			title: "Citizenship by Investment",
			image: getImage(data.citizenshipImage),
			link: "/our-services/citizenship-by-investment/",
			description: "Our residency and citizenship by investment programmes open up a world of opportunities for you and your family.",
		},
		{
			title: "Estate Planning",
			image: getImage(data.estatePlanningImage),
			link: "/our-services/estate-planning/",
			description: "Estate planning is crucial to secure your legacy and ensure your loved ones are financially protected.",
		},
		{
			title: "Financial Planning",
			image: getImage(data.financialPlanningImage),
			link: "/our-services/financial-planning/",
			description: "Make informed decisions and secure your future with expert advice tailored to your needs and goals.",
		},
		{
			title: "Investments",
			image: getImage(data.investmentsImage),
			link: "/our-services/investments/",
			description: "We offer short and long-term investment solutions with a wide range of portfolio options to suit your goals and risk profile.",
		},
		{
			title: "Retirement Planning",
			image: getImage(data.retirementPlanningImage),
			link: "/our-services/retirement-planning/",
			description: "A retirement planning strategy gives you a clear roadmap to help you take control of your finances and build a more secure future.",
		},
		{
			title: "Wealth Management",
			image: getImage(data.wealthManagementImage),
			link: "/our-services/wealth-management/",
			description: "Wealth management is a comprehensive service that helps you effectively manage, grow and protect your wealth.",
		},
	]

	// Children

	const retirement = [
		{
			title: "Provident Pension Fund",
			image: getImage(data.providentPensionFund),
			link: "/our-services/retirement-planning/provident-pension-fund/",
			description: "Provident pension funds provide a tax-efficient way to save for retirement.",
		},
		{
			title: "Annuities",
			image: getImage(data.annuities),
			link: "/our-services/retirement-planning/annuities/",
			description: "Annuities allow you to create a secure income that lasts the rest of your life.",
		},
		{
			title: "UK pension transfer",
			image: getImage(data.pensionTransfer),
			link: "/our-services/retirement-planning/uk-pension-transfer/",
			description: "Transferring your UK pension to another scheme or provider could unlock your retirement savings potential.",
		},
		{
			title: "UK state pension",
			image: getImage(data.statePension),
			link: "/our-services/retirement-planning/uk-state-pension/",
			description: "The UK State Pension is a regular payment made by the UK government once you reach a certain age.",
		},
		{
			title: "UK pension",
			image: getImage(data.pension),
			link: "/our-services/retirement-planning/uk-pension/",
			description: "UK pensions provide a tax-efficient way of saving for retirement and planning for your future.",
		}
	]

	const investments = [
		{
			title: "International Investments",
			image: getImage(data.internationalInvestments),
			link: "/our-services/investments/international-investments/",
			description: "Global investment strategies can provide an effective way to diversify your investment portfolio.",
		},
		{
			title: "Asset portfolio management",
			image: getImage(data.assetPortfolioManagement),
			link: "/our-services/investments/asset-and-portfolio-management/",
			description: "Expertly managed investment portfolios that align with your long-term financial objectives.",
		},
		{
			title: "Education Planning",
			image: getImage(data.educationPlanning),
			link: "/our-services/investments/education-planning/",
			description: "Education planning allows you to start planning today and ensure you are prepared for your child's future education costs.",
		},
		{
			title: "Local Investments",
			image: getImage(data.localInvestments),
			link: "/our-services/investments/local-investments/",
			description: "Explore local investment opportunities that align with your needs and goals.",
		},
	]



	const estate = [
		{
			title: "Wills",
			image: getImage(data.wills),
			link: "/our-services/estate-planning/wills/",
			description: "Our will-writing services help ensure your final wishes are carried out.",
		},
		{
			title: "Trusts & Gifting",
			image: getImage(data.trustAndGifting),
			link: "/our-services/estate-planning/trusts-and-gifting/",
			description: "Legal structures that help you effectively manage and pass on your assets.",
		},
	]




	let sectionTitle;
	let selectedServices;
	let gridClasses;

	switch (category) {
		case 'investments':
			selectedServices = investments;
			sectionTitle = "Our Investment Services";
			gridClasses = "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10";
			break;
		case 'retirement':
			selectedServices = retirement;
			sectionTitle = "Our Retirement Planning Services";
			gridClasses = "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10";
			break;
		case 'estate':
			selectedServices = estate;
			sectionTitle = "Our Estate Planning Services";
			gridClasses = "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-10";
			break;
		default:
			selectedServices = services;
			sectionTitle = "Our Areas of Expertise";
			gridClasses = "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-10";
	}

	return (
			<section className="services bg-white">
			<div className="grid grid-cols-1 lg:grid-cols-12 gap-14 mx-auto text-center">
				<div className="col-span-full lg:col-span-10 lg:col-start-2 lg:col-end-12">
					<h2 className="text-3xl mb-6 font-semibold">{sectionTitle}</h2>
					<div className={gridClasses}>
						{(category === 'estate' || category === 'taxPlanning') && <div className="hidden xl:block xl:col-span-1"></div>}
						{selectedServices.map((service, index) => (
						<Link key={index} to={service.link}>
							<div className="services-card bg-light-blue h-full rounded-2xl">
							<div className="services-card-image">
								<GatsbyImage image={service.image} alt={service.title} className="rounded-t-2xl"/>
							</div>
							<div className="services-content-wrapper p-6">
								<div className="services-card-title">
								<h4 className="pb-0">{service.title}</h4>
								</div>
								{service.description && (
								<div className="services-card-text flex-grow pt-4">
									<p>{service.description}</p>
								</div>
								)}
							</div>
							</div>
						</Link>
						))}
					</div>
				</div>
		  	</div>
		</section>
	)
}

export default Services;

